// src/components/ScrollToTop.js
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to the top when path changes
    window.scrollTo(0, 0);
  }, [pathname]);

  return null; // This component doesn’t render anything
};

export default ScrollToTop;
